import styled from "styled-components/macro";

export default styled.label`
  font-weight: 600;
  line-height: 1;
  margin-bottom: 12px;
`;
